import { userIsGroupAdmin } from '../../functions/user.functions';

export default function AccessManagementRouteConfig($stateProvider) {
  'ngInject';

  $stateProvider
    .state('access-management', {
      url: '/access-management',
      template: `<access-management></access-management>`,
      redirectTo: 'access-management.assets-list',
      ncyBreadcrumb: {
        label: "{{'Access Management' | translate}}",
      },
      requiredFeatures: ['access'],
    })
    .state('access-management.group-list', {
      url: '/group-list',
      template: '<am-group-list></am-group-list>',
      ncyBreadcrumb: {
        label: "{{'Groups' | translate}}",
      },
      requiredFeatures: ['access.group_admin'],
    })
    .state('access-management.group-view', {
      url: '/group-view/:id',
      template: '<am-group-view></am-group-view>',
      ncyBreadcrumb: {
        label: "{{'Group Details' | translate}}",
        parent: 'access-management.group-list',
      },
      requiredFeatures: ['access.group_admin'],
    })
    .state('access-management.group-create', {
      url: '/group-create',
      template: '<am-group-create></am-group-create>',
      ncyBreadcrumb: {
        label: "{{'Create Group' | translate}}",
      },
      requiredFeatures: ['access.group_admin'],
    })
    .state('access-management.operators-list', {
      url: '/operators',
      template: '<am-operators-list></am-operators-list>',
      ncyBreadcrumb: {
        label: "{{'Operators' | translate}}",
      },
      requiredFeatures: ['access.operator_admin'],
    })
    .state('access-management.operator-view', {
      url: '/operator/:id',
      template: '<am-operator-view></am-operator-view>',
      ncyBreadcrumb: {
        label: "{{'Operator Details' | translate}}",
        parent: 'access-management.operators-list',
      },
      requiredFeatures: ['access.operator_admin'],
    })
    .state('access-management.operators-bulk-upload', {
      url: '/create/operator/bulk',
      template: ' <am-bulk-upload-operators></am-bulk-upload-operators>',
      ncyBreadcrumb: {
        label: "{{'Create Operators' | translate}}",
        parent: 'access-management',
      },
      requiredFeatures: ['access.operator_admin'],
    })
    .state('access-management.operator-create', {
      url: '/create/operator',
      template: ' <am-operator-create></am-operator-create>',
      ncyBreadcrumb: {
        label: "{{'Create Operator' | translate}}",
        parent: 'access-management',
      },
      requiredFeatures: ['access.operator_admin'],
    })
    .state('access-management.assets-list', {
      url: '/assets',
      template: '<am-assets-list poll="true" show-enable-assets="true"></am-assets-list>',
      ncyBreadcrumb: {
        label: "{{'Assets' | translate}}",
      },
      requiredFeatures: ['access.operator_admin'],
    })
    .state('access-management.asset-view', {
      url: '/assets/:id',
      template: '<am-asset-view></am-asset-view>',
      ncyBreadcrumb: {
        label: "{{'Asset Details' | translate}}",
        parent: 'access-management.assets-list',
      },
      requiredFeatures: ['access.operator_admin'],
    })
    .state('access-management.assignments', {
      url: '/assignments',
      template: '<am-assignments></am-assignments>',
      ncyBreadcrumb: {
        label: "{{'Assignments' | translate}}",
      },
      requiredFeatures: ['access.operator_admin'],
    });
}
